@if (
  control &&
  control.invalid &&
  control.touched) {
  <sdx-validation-message
    [validationMessage]="getErrorMessage()"
    class="hydrated">
  </sdx-validation-message>
}
